export default __webpack_public_path__ + "static/media/testify12.f7a214e4.png";